import { MEDIA_TYPES } from 'dedicated/components/choose-plan/plan.service';
import { computeBandwidth } from 'home/view/manage-feasibility/utils/multiSite-utils';
import React, { useState } from 'react';

type Props = {
  feasibilityResponseBulk: { eligibleMedia: Array<any>; maxBandwidth: number };
};

export const MediaType = ({ feasibilityResponseBulk }: Props) => {
  const [isViewAll, setIsViewAll] = useState(false);
  const maxBandwidth = feasibilityResponseBulk.maxBandwidth ? computeBandwidth(feasibilityResponseBulk.maxBandwidth) : '-';
  const firstMedia = feasibilityResponseBulk?.eligibleMedia?.[0]?.media || '-';
  const isSecondMediaAvail = feasibilityResponseBulk?.eligibleMedia?.length > 1;

  const toggleViewAll = () => {
    setIsViewAll(!isViewAll);
  };

  const getTowerHeight = (data: { rfTowerHeight: string; media: string }) => {
    if (data?.media === MEDIA_TYPES.RF_P2P) {
      return <span className="subvalue white-space-pre ">{`(${data?.rfTowerHeight})` || '-'}</span>;
    }
  };

  const renderMedia = () => {
    const lastIndex = isViewAll ? feasibilityResponseBulk?.eligibleMedia?.length : 1;
    return feasibilityResponseBulk?.eligibleMedia?.slice(0, lastIndex).map((data) => {
      const media = data?.media || '-';
      return (
        <div>
          {media} {getTowerHeight(data)}{' '}
        </div>
      );
    });
  };

  return (
    <>
      {renderMedia()}
      <div className="subvalue white-space-pre ">{maxBandwidth}</div>
      {isSecondMediaAvail && (
        <span className="media-view-all" onClick={toggleViewAll}>
          {isViewAll ? 'View Less' : 'View All'}
        </span>
      )}
    </>
  );
};
